import { useAsync } from 'react-use';

import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const useGetTeams = () => {
  const catalogApi = useApi(catalogApiRef);

  const { value: teamsById = new Map<string, string>(), loading } =
    useAsync(async () => {
      const groups = await catalogApi.getEntities({
        filter: {
          kind: 'group',
          'spec.type': 'supervisory-org',
        },
        fields: ['metadata.name', 'metadata.title'],
      });

      const map = new Map<string, string>();
      groups.items.forEach(e => {
        const id = e.metadata.name.toUpperCase();
        const displayName = (e.metadata.title || e.metadata.name) as string;
        map.set(id, displayName);
      });
      return map;
    }, [catalogApi]);

  return { teamsById, loading };
};
